import { SCREEN_NAMES } from '@/lib/analytics/consts.ts'

export const CHATBOTIZE_SCRIPT_PATH = '/web/live-chat/chatbotize-entrypoint.min.js'

export const ZOWIE_WIDGET_SCRIPT_PATH = '/web/chat-widget/zowie-widget-entry.js'

export const REFERRALS = {
  COVER_PHOTO: 'cover_photo',
  PORTFOLIO_MAIN: 'portfolio_main',
  SERVICES: 'services',
  BUSINESS_HOURS: 'business_hours',
} as const

export const REFERRAL_SCREEN_NAMES_MAP = {
  [REFERRALS.COVER_PHOTO]: SCREEN_NAMES.COVER_PHOTO,
  [REFERRALS.PORTFOLIO_MAIN]: SCREEN_NAMES.PORTFOLIO_MAIN,
  [REFERRALS.SERVICES]: SCREEN_NAMES.SERVICES,
  [REFERRALS.BUSINESS_HOURS]: SCREEN_NAMES.BUSINESS_HOURS,
} as const

export const DEFAULT_SCREEN_NAME = SCREEN_NAMES.OTHER
